// extracted by mini-css-extract-plugin
export default {"wrapper":"library_wrapper__6FYYF","body":"library_body__MMXqx","main_wrapper":"library_main_wrapper__g-amt","title":"library_title__jQDtP","content":"library_content__JG-jL"};